import { ApolloClient } from '@apollo/client';
import { CurrentUserDocument, CurrentUserQuery } from './graphql.generated';

export const getCurrentUser = async (apolloClient: ApolloClient<unknown>) => {
	const currentUserQuery = await apolloClient.query<CurrentUserQuery>({
		query: CurrentUserDocument,
	});
	return currentUserQuery?.data?.currentUser;
};
